import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { useGetCoachesListQuery } from '../store/Api';
interface Props {
  formProps?: FormItemProps;
  oneSelectMode?: boolean;
}

export function CoachesSelector({ formProps, oneSelectMode }: Props) {
  const { data: coaches, isLoading } = useGetCoachesListQuery();

  if (isLoading) {
    return <LoadingOutlined />;
  }

  if (coaches === undefined) {
    return;
  }

  return (
    <Form.Item
      label={t('form-items.select.coach')}
      name={oneSelectMode ? 'coachId' : 'coachsId'}
      {...formProps}
    >
      <Select
        optionFilterProp="label"
        showSearch
        {...(oneSelectMode ? {} : { mode: 'multiple' })}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
        options={coaches.map((coach) => ({
          label: coach.name,
          value: coach.id
        }))}
      />
    </Form.Item>
  );
}
